export const SenderRegistrationMock = {
  firstName: '',
  middleName: '',
  lastName: '',
  secondLastName: '',
  email: '',
  notificationLanguagePreference: '',
  address: {
    line1: '',
    line2: '',
    city: '',
    countrySubdivisionCode: '',
    countryCode: '',
    postalCode: '',
  },
  dateOfBirth: '',
  mobilePhone: {
    number: '',
    countryDialCode: '',
  },
  birthCountryCode: '',
  primaryIdentification: {
    typeCode: '',
    id: '',
    issueCountrySubdivisionCode: '',
    issueCountryCode: '',
  },
  secondaryIdentification: {
    typeCode: '',
    id: '',
    issueCountrySubdivisionCode: '',
    issueCountryCode: '',
  },
  politicalExposedPerson: false,
};

export const PaymentDetailsMock = [
  {
    accountBin: '',
    accountMgiToken: '',
    cardProvider: '',
    cardsubType: '',
    expirationDate: new Date(),
    lastFour: '',
    paymentProcessor: '',
  },
];

export const AmountDetailsMock = {
  value: 0,
  currencyCode: '',
};

export const PayAmountDetailsMock = {
  amount: AmountDetailsMock,
  fees: AmountDetailsMock,
  taxes: AmountDetailsMock,
  totalAmount: AmountDetailsMock,
  promotionDetails: [],
};

export const FxRateMockData = {
  fxRate: 0,
  currency: 'USD',
};
